import styled, { css } from 'styled-components';
import { Picklist } from 'react-rainbow-components';
import { DIVIDER } from '../../constants';

export default styled(Picklist)`
    label {
        color: rgb(63, 73, 84);
        font-size: 0.875rem;
        line-height: 1.5;
        margin-bottom: 0.125rem;
        align-self: flex-start;
        box-sizing: border-box;
        margin-left: 1rem;
    }

    ${(props) => props.variant !== 'bare' && css`
        input {
            border: 1px solid ${DIVIDER};
            border-radius: 0.625rem;

            ::placeholder {
                font-weight: 300 !important;
            }
        }
    `};

    ${(props) => props.variant === 'bare' && css`
        input {
            border: none;
            border-radius: 0.625rem;
            background: transparent;

            ::placeholder {
                font-weight: 300 !important;
            }
        }
    `};

    ${(props) => props.readOnly && css`
        input {
            border: none;
            border-radius: 0.625rem;   
        }
    `};

    div[id^="error-message"] {
        align-self: flex-start;
    }
`;
